(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[14],{

/***/ "+mFE":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"favoritePopperHeader":"vBtrte","favoritePopperTitle":"jUYOaK","close":"_3bG2oD","backClose":"_2hTZYD"};

/***/ }),

/***/ "0goB":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"compareWrapper":"zw2fv7","checkbox":"_1qcxff","home":"_3fVp1X","label":"i4hgG9","alerWrapper":"_2Xrk01","alertPopper":"_1KYO_u","alertPopperText":"_3sJwSL"};

/***/ }),

/***/ "3ZwB":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"newListButton":"_1fiNGr","icons":"_9iBPXg","text":"VUl8QH"};

/***/ }),

/***/ "Alsq":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"saveInput":"stzSqm","visible":"_23bKM0","cancelInput":"_2CHDCK","input":"_2rv3UL","newListTitle":"_2XeiDx"};

/***/ }),

/***/ "JxNw":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2XVULN","content":"_1xFjvF"};

/***/ }),

/***/ "Vu+8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"favoritePopUp":"_2Wmxcc","modalStyle":"_3K9T11","modalStyleBox":"_1hQhy9"};

/***/ }),

/***/ "o58N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("KQm4");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HaE+");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1OyB");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("vuIU");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("JX7q");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Ji7U");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("md7G");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("foSv");
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("wx14");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("/MKj");
/* harmony import */ var _redux_store_containers_compare__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("azk1");
/* harmony import */ var _elements__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("9aJQ");
/* harmony import */ var _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("0cs1");
/* harmony import */ var _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("+qgJ");
/* harmony import */ var _material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _services_listingService__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("dYvW");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("SUMQ");
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("JOJA");
/* harmony import */ var _material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("XaW4");
/* harmony import */ var _material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _helpers_notifier__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("Z0GP");
/* harmony import */ var _helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("tkT3");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("0goB");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_24__);











var __jsx = react__WEBPACK_IMPORTED_MODULE_11___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/jsx-wrap-multilines */














var CustomCheckbox = Object(_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_19__["withStyles"])({
  root: {
    height: 24,
    color: '#FFF',
    '&$checked': {
      color: '#FFF'
    }
  },
  checked: {} // eslint-disable-next-line arrow-body-style

})(function (props) {
  return __jsx(_material_ui_core_Checkbox__WEBPACK_IMPORTED_MODULE_21___default.a, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_10__[/* default */ "a"])({
    color: "default"
  }, props));
});

var CompareButton = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(CompareButton, _Component);

  var _super = _createSuper(CompareButton);

  function CompareButton() {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(this, CompareButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "state", {
      open: false,
      anchorEl: null,
      checked: false,
      arrowRef: null
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "setChecked", function (listing) {
      var compare = typeof navigator !== 'undefined' && navigator.cookieEnabled ? localStorage.getItem('compareListing') || [] : [];
      var checked = compare.includes(listing.id);

      _this.setState({
        checked: checked
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "handleChange", function () {
      var checked = _this.state.checked;

      _this.setState({
        checked: !checked
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "handleClose", function () {
      _this.setState({
        open: false
      });
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "handleClick", function (event) {
      var currentTarget = event.currentTarget;
      var checked = _this.state.checked;
      var _this$props = _this.props,
          compareListings = _this$props.compareListings,
          addListingToCompareList = _this$props.addListingToCompareList,
          removeListingFromCompareList = _this$props.removeListingFromCompareList,
          listing = _this$props.listing,
          detail = _this$props.detail,
          gtmEventLabel = _this$props.gtmEventLabel;

      if (!checked && compareListings.length >= 4) {
        if (detail) {
          Object(_helpers_notifier__WEBPACK_IMPORTED_MODULE_22__[/* default */ "a"])('En fazla 4 ilan seçebilirsin.', 'error');
          return;
        }

        _this.setState({
          anchorEl: currentTarget,
          open: true
        });

        setTimeout(function () {
          _this.setState({
            open: false
          });
        }, 5000);
        return;
      }

      if (!checked) {
        var isListingDataFromNODE = listing.title.tr;
        Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_23__[/* compareAddGTMEvents */ "f"])({
          label: gtmEventLabel
        });

        if (isListingDataFromNODE) {
          _this.addListing();
        } else {
          addListingToCompareList(listing);
        }
      } else {
        Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_23__[/* compareRemoveGTMEvents */ "g"])({
          label: gtmEventLabel
        });
        removeListingFromCompareList(listing);
      }
    });

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "addListing", /*#__PURE__*/Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
      var _this$props2, addListingToCompareList, listing, listingDataFromApi, listingData;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, addListingToCompareList = _this$props2.addListingToCompareList, listing = _this$props2.listing;
              _context.next = 3;
              return Object(_services_listingService__WEBPACK_IMPORTED_MODULE_18__[/* getListingDetail */ "b"])(listing.id);

            case 3:
              listingDataFromApi = _context.sent;
              listingData = listingDataFromApi.result;
              addListingToCompareList(listingData);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_this), "handleArrowRef", function (node) {
      _this.setState({
        arrowRef: node
      });
    });

    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(CompareButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var listing = this.props.listing;
      this.setChecked(listing);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var listing = nextProps.listing;
      this.setChecked(listing);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$state = this.state,
          open = _this$state.open,
          anchorEl = _this$state.anchorEl,
          checked = _this$state.checked,
          arrowRef = _this$state.arrowRef;
      var _this$props3 = this.props,
          isCompare = _this$props3.isCompare,
          detail = _this$props3.detail,
          home = _this$props3.home,
          style = _this$props3.style,
          dataEjCategory = _this$props3['data-ej-category'],
          dataEjAction = _this$props3['data-ej-action'],
          dataEjLabel = _this$props3['data-ej-label'];
      var id = open ? 'simple-popper' : null;
      var checkboxClassNames = classnames__WEBPACK_IMPORTED_MODULE_12___default()((_classNames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.checkbox, true), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.home, home), _classNames));
      return __jsx(react__WEBPACK_IMPORTED_MODULE_11__["Fragment"], null, __jsx(_elements__WEBPACK_IMPORTED_MODULE_15__[/* Button */ "b"], {
        secondary: !isCompare,
        blanked: isCompare,
        transparent: detail,
        variant: "contained",
        onClick: this.handleClick,
        style: _objectSpread({
          display: 'flex',
          backgroundColor: 'yellow',
          boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.2)'
        }, style),
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction,
        "data-ej-label": dataEjLabel
      }, __jsx("div", {
        className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.compareWrapper,
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction,
        "data-ej-label": dataEjLabel
      }, detail ? __jsx(_elements__WEBPACK_IMPORTED_MODULE_15__[/* Icon */ "e"], {
        name: "control_point_duplicate",
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction,
        "data-ej-label": dataEjLabel
      }) : __jsx(_material_ui_core_FormControlLabel__WEBPACK_IMPORTED_MODULE_20___default.a, {
        className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.label,
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction,
        "data-ej-label": dataEjLabel,
        control: __jsx("div", {
          "data-ej-category": dataEjCategory,
          "data-ej-action": dataEjAction,
          "data-ej-label": dataEjLabel
        }, __jsx(CustomCheckbox, {
          disableRipple: true,
          className: checkboxClassNames,
          checked: checked,
          onChange: this.handleClick,
          inputProps: {
            'data-ej-category': dataEjCategory,
            'data-ej-action': dataEjAction,
            'data-ej-label': dataEjLabel
          }
        }))
      }), __jsx("div", {
        style: detail ? {
          lineHeight: '24px'
        } : {
          margin: '0 auto',
          lineHeight: '24px'
        },
        "data-ej-category": dataEjCategory,
        "data-ej-action": dataEjAction,
        "data-ej-label": dataEjLabel
      }, detail ? checked ? 'Karşılaştırmaya eklendi' : 'İlanı Karşılaştır' : 'Karşılaştır'))), __jsx(_material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_16___default.a, {
        id: id,
        open: open,
        anchorEl: anchorEl,
        placement: home ? 'top' : 'left',
        disablePortal: true,
        modifiers: {
          flip: {
            enabled: true
          },
          preventOverflow: {
            enabled: false,
            boundariesElement: 'scrollParent'
          },
          arrow: {
            enabled: true,
            element: arrowRef
          }
        }
      }, __jsx(_material_ui_core_ClickAwayListener__WEBPACK_IMPORTED_MODULE_17___default.a, {
        onClickAway: this.handleClose
      }, home ? __jsx("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, __jsx("div", {
        className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.alertPopper
      }, __jsx("p", {
        className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.alertPopperText
      }, " En Fazla 4 \u0130lan Se\xE7ebilirsin")), __jsx("i", {
        className: "material-icons",
        ref: this.handleArrowRef,
        style: {
          color: 'rgb(241, 102, 102)',
          marginTop: '-6%',
          alignSelf: 'center'
        }
      }, "arrow_drop_down")) : __jsx("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, __jsx("div", {
        className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.alertPopper
      }, __jsx("p", {
        className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_24___default.a.alertPopperText
      }, " En Fazla 4 \u0130lan Se\xE7ebilirsin")), __jsx("i", {
        className: "material-icons",
        ref: this.handleArrowRef,
        style: {
          color: 'rgb(241, 102, 102)',
          marginLeft: '-10px',
          WebkitTransform: 'rotate(-90deg)',
          MozTransform: 'rotate(-90deg)',
          msTransform: 'rotate(-90deg)',
          Otransform: 'rotate(-90deg)',
          transform: 'rotate(-90deg)'
        }
      }, "arrow_drop_down")))));
    }
  }]);

  return CompareButton;
}(react__WEBPACK_IMPORTED_MODULE_11__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (react_redux__WEBPACK_IMPORTED_MODULE_13__[/* connect */ "b"].apply(void 0, Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_redux_store_containers_compare__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"]))(CompareButton));

/***/ }),

/***/ "qRZG":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"plRxQs","itemTitle":"_3Z_bGr","icons":"_1h3-g0","text":"rqADHf","title":"_3xheGB","count":"_2EVr53","coverPhoto":"_2RoXoZ","threeDot":"Nh9djs","successMessage":"_1sZCkz","hoverButton":"_14GFMf"};

/***/ }),

/***/ "xKmG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./src/redux-store/containers/favorites/index.js + 1 modules
var favorites = __webpack_require__("FWZ+");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events.js
var events = __webpack_require__("tkT3");

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events/homepage.js
var homepage = __webpack_require__("XsDQ");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events/listing-search.js
var listing_search = __webpack_require__("/n9I");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events/listing-detail.js
var listing_detail = __webpack_require__("UYDH");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/index.js
var google_tag_manager = __webpack_require__("kqSB");

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-button/index.jsx

var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var favorite_button_onHandleClick = function onHandleClick(onClick, event, listingItem, itemIndex, pageNumber, gtmEventLabel, isFavorited) {
  onClick(event);
  /* GTM Events */

  if (!isFavorited) {
    switch (gtmEventLabel) {
      case 'listeleme':
        Object(listing_search["listingAddFavoriteGtmEvent"])(listingItem, itemIndex, pageNumber);
        break;

      case 'emlak-ofisleri':
        Object(homepage["homeAddFavoriteGtmEvent"])(listingItem, itemIndex, 'emlak-ofisleri');
        break;

      case 'one-cikan-ilanlar':
        Object(homepage["homeAddFavoriteGtmEvent"])(listingItem, itemIndex, 'ana-sayfa');
        break;

      case 'detay':
        Object(listing_detail["listingDetailAddFavoriteGtmEvent"])(listingItem);
        break;

      case 'emlak-ofisi-detay':
        Object(listing_detail["agentDetailAddFavoriteGTMEvent"])(event, listingItem, itemIndex, pageNumber);
        break;

      case 'jetfirsat':
        Object(google_tag_manager["a" /* GTMPushEvent */])({
          event: 'ga4_event',
          event_name: 'click_favorite',
          event_parameters: {
            item_list_name: 'jetfirsat-ara-modul'
          }
        });
        break;

      default:
        break;
    }

    Object(events["o" /* formGTMEventGA4 */])({
      eventName: 'click_favorite',
      eventParameters: {
        item_id: "".concat(listingItem.id)
      }
    });
  } else {
    var _listingItem$price, _listingItem$priceDet;

    Object(google_tag_manager["a" /* GTMPushEvent */])({
      event: 'vlEvent',
      vl_label: 'VL-RemoveFav',
      vl_product: {
        id: listingItem.id,
        qty: '-1',
        price: (listingItem === null || listingItem === void 0 ? void 0 : (_listingItem$price = listingItem.price) === null || _listingItem$price === void 0 ? void 0 : _listingItem$price.value) || (listingItem === null || listingItem === void 0 ? void 0 : (_listingItem$priceDet = listingItem.priceDetail) === null || _listingItem$priceDet === void 0 ? void 0 : _listingItem$priceDet.price) || 0
      }
    });
  }
};

var favorite_button_FavoriteButton = function FavoriteButton(_ref) {
  var open = _ref.open,
      detail = _ref.detail,
      _onClick = _ref.onClick,
      dataEjAction = _ref.dataEjAction,
      dataEjCategory = _ref.dataEjCategory,
      dataEjLabel = _ref.dataEjLabel,
      style = _ref.style,
      isFavorited = _ref.isFavorited,
      listingItem = _ref.listingItem,
      itemIndex = _ref.itemIndex,
      pageNumber = _ref.pageNumber,
      gtmEventLabel = _ref.gtmEventLabel;
  return __jsx(desktop_elements["b" /* Button */], {
    secondary: !isFavorited,
    "aria-describedby": open ? 'simple-popper' : null,
    transparent: detail,
    variant: "contained",
    onClick: function onClick(e) {
      return favorite_button_onHandleClick(_onClick, e, listingItem, itemIndex, pageNumber, gtmEventLabel, isFavorited);
    },
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": dataEjLabel,
    style: open ? _objectSpread({
      visibility: 'visible',
      boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.2)'
    }, style) : _objectSpread({
      boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.2)'
    }, style)
  }, __jsx("div", {
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": dataEjLabel,
    style: detail ? {
      display: 'flex',
      alignItems: 'center'
    } : null
  }, __jsx(desktop_elements["e" /* Icon */], {
    name: isFavorited ? 'favorite' : 'favorite_border',
    style: isFavorited ? {
      color: '#58b847'
    } : null,
    "data-ej-category": dataEjCategory,
    "data-ej-action": dataEjAction,
    "data-ej-label": dataEjLabel
  }), isFavorited ? 'Favori ilan' : 'Favorilere Ekle'));
};

/* harmony default export */ var favorite_button = (favorite_button_FavoriteButton);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/Modal/index.js
var Modal = __webpack_require__("hzb6");
var Modal_default = /*#__PURE__*/__webpack_require__.n(Modal);

// EXTERNAL MODULE: ./src/components/desktop/favorites/favorite-popper/styles.module.scss
var styles_module = __webpack_require__("Vu+8");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper/index.jsx
var favorite_popper_jsx = react_default.a.createElement;




var favorite_popper_FavoritePopper = function FavoritePopper(_ref) {
  var open = _ref.open,
      onClick = _ref.onClick,
      children = _ref.children;
  return favorite_popper_jsx(react_default.a.Fragment, null, favorite_popper_jsx(Modal_default.a, {
    open: open,
    onClose: function onClose() {
      return onClick();
    }
  }, favorite_popper_jsx("div", {
    className: styles_module_default.a.modalStyle
  }, favorite_popper_jsx("div", {
    className: styles_module_default.a.modalStyleBox
  }, children), favorite_popper_jsx(FavoritePopper, null))));
};

/* harmony default export */ var favorite_popper = (favorite_popper_FavoritePopper);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// CONCATENATED MODULE: ./src/components/desktop/favorites/test-selector-ids.js
var favoriteModalAddToListTitle = 'favorite-modal-add-to-list-title';
var favoriteModalCreateNewListTitle = 'favorite-modal-create-new-list-title';
var favoriteModalCreateNewListButton = 'favorite-modal-create-new-list-button';
var favoriteModalCloseButton = 'favorite-modal-close-button';
var favoriteModalListNameInput = 'favorite-modal-list-name-input';
var favoriteModalSaveButton = 'favorite-modal-save-button';
var favoriteModalCancelButton = 'favorite-modal-cancel-button';
var favoriteModalListItem = 'favorite-modal-list-item';
// EXTERNAL MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-popper-header/styles.module.scss
var favorite_popper_header_styles_module = __webpack_require__("+mFE");
var favorite_popper_header_styles_module_default = /*#__PURE__*/__webpack_require__.n(favorite_popper_header_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-popper-header/index.jsx
var favorite_popper_header_jsx = react_default.a.createElement;





var favorite_popper_header_FavoritePopperHeader = function FavoritePopperHeader(_ref) {
  var onClick = _ref.onClick,
      title = _ref.title,
      back = _ref.back,
      titleTestSelector = _ref.titleTestSelector;
  return favorite_popper_header_jsx("div", {
    className: favorite_popper_header_styles_module_default.a.favoritePopperHeader
  }, favorite_popper_header_jsx("p", {
    className: favorite_popper_header_styles_module_default.a.favoritePopperTitle,
    "data-test-selector": titleTestSelector
  }, title), favorite_popper_header_jsx("div", {
    className: favorite_popper_header_styles_module_default.a.backClose,
    transparent: true,
    onClick: onClick,
    "data-test-selector": favoriteModalCloseButton
  }, back ? favorite_popper_header_jsx(react_default.a.Fragment, null, favorite_popper_header_jsx(desktop_elements["e" /* Icon */], {
    name: "arrow_back",
    style: {
      fontSize: '14px',
      color: '#64707c'
    }
  }), favorite_popper_header_jsx("span", {
    style: {
      fontSize: '14px',
      color: '#64707c',
      fontWeight: 'normal'
    }
  }, "Geri D\xF6n")) : favorite_popper_header_jsx(react_default.a.Fragment, null, favorite_popper_header_jsx(desktop_elements["e" /* Icon */], {
    className: favorite_popper_header_styles_module_default.a.close,
    name: "close"
  }))));
};

/* harmony default export */ var favorite_popper_header = (favorite_popper_header_FavoritePopperHeader);
// EXTERNAL MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-empty-state/styles.module.scss
var favorite_empty_state_styles_module = __webpack_require__("y4vh");
var favorite_empty_state_styles_module_default = /*#__PURE__*/__webpack_require__.n(favorite_empty_state_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-empty-state/index.jsx
var favorite_empty_state_jsx = react_default.a.createElement;






var favorite_empty_state_FavoriteEmptyState = function FavoriteEmptyState(_ref) {
  var changeCurrentPopperContent = _ref.changeCurrentPopperContent,
      handleClosePopper = _ref.handleClosePopper;
  return favorite_empty_state_jsx("div", {
    className: favorite_empty_state_styles_module_default.a.favoriteEmptyState
  }, favorite_empty_state_jsx(favorite_popper_header, {
    onClick: handleClosePopper,
    title: "Favori Listeme Ekle",
    titleTestSelector: favoriteModalAddToListTitle
  }), favorite_empty_state_jsx("div", {
    className: favorite_empty_state_styles_module_default.a.content
  }, favorite_empty_state_jsx("div", {
    className: favorite_empty_state_styles_module_default.a.textWrapper
  }, favorite_empty_state_jsx("p", {
    className: favorite_empty_state_styles_module_default.a.text
  }, "Favori listeniz bulunmamaktad\u0131r. \u0130lan\u0131 favorilerinize eklemek i\xE7in yeni liste olu\u015Fturabilirsiniz.")), favorite_empty_state_jsx("div", {
    className: favorite_empty_state_styles_module_default.a.listButton,
    onClick: function onClick() {
      changeCurrentPopperContent('new-list');
    },
    "data-test-selector": favoriteModalCreateNewListButton
  }, favorite_empty_state_jsx(desktop_elements["e" /* Icon */], {
    name: "add_circle_outline"
  }), favorite_empty_state_jsx("span", null, "Yeni Liste Olu\u015Ftur"))));
};

/* harmony default export */ var favorite_empty_state = (favorite_empty_state_FavoriteEmptyState);
// EXTERNAL MODULE: ./src/components/e6t/desktop/input/index.jsx + 5 modules
var input = __webpack_require__("66jO");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-create-list/styles.module.scss
var favorite_create_list_styles_module = __webpack_require__("Alsq");
var favorite_create_list_styles_module_default = /*#__PURE__*/__webpack_require__.n(favorite_create_list_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-create-list/index.jsx


var favorite_create_list_jsx = react_default.a.createElement;

function favorite_create_list_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function favorite_create_list_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { favorite_create_list_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { favorite_create_list_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var favorite_create_list_FavoriteCreateList = function FavoriteCreateList(_ref) {
  var _classNames;

  var favoriteList = _ref.favoriteList,
      changeCurrentPopperContent = _ref.changeCurrentPopperContent,
      error = _ref.error,
      createFavoriteList = _ref.createFavoriteList;

  var _useState = Object(react["useState"])({
    listname: null,
    loading: false,
    errors: {
      listname: !!error,
      message: error ? '* Aynı isimde bir listen zaten mevcut' : null
    }
  }),
      states = _useState[0],
      setStates = _useState[1];

  var saveButton = classnames_default()((_classNames = {}, Object(defineProperty["default"])(_classNames, favorite_create_list_styles_module_default.a.saveInput, true), Object(defineProperty["default"])(_classNames, favorite_create_list_styles_module_default.a.visible, states.listname && states.listname.length > 0), _classNames));

  var backButton = function backButton() {
    if (favoriteList && favoriteList.length > 0) {
      changeCurrentPopperContent('list');
    } else {
      changeCurrentPopperContent('empty');
    }
  };

  var handleInputOnChange = function handleInputOnChange(e) {
    var value = e.target.value;
    setStates(favorite_create_list_objectSpread(favorite_create_list_objectSpread({}, states), {}, {
      listname: value
    }));
  };

  var handleCreateList = function handleCreateList() {
    var listname = states.listname;

    if (listname) {
      createFavoriteList(listname);
    }
  };

  return favorite_create_list_jsx(react_default.a.Fragment, null, favorite_create_list_jsx(favorite_popper_header, {
    onClick: backButton,
    title: "Yeni Liste Olu\u015Ftur",
    titleTestSelector: favoriteModalCreateNewListTitle
  }), favorite_create_list_jsx("div", {
    style: favorite_create_list_styles_module_default.a.content
  }, favorite_create_list_jsx("div", {
    style: favorite_create_list_styles_module_default.a.form
  }, favorite_create_list_jsx(input["a" /* default */], {
    label: "Liste Ad\u0131",
    error: states.errors.listname,
    onChange: handleInputOnChange,
    helperText: states.errors.message,
    value: states.listname,
    className: favorite_create_list_styles_module_default.a.input,
    "data-test-selector": favoriteModalListNameInput
  }), favorite_create_list_jsx("div", {
    className: saveButton,
    onClick: handleCreateList,
    "data-test-selector": favoriteModalSaveButton
  }, "Kaydet"), favorite_create_list_jsx("div", {
    className: favorite_create_list_styles_module_default.a.cancelInput,
    onClick: backButton,
    "data-test-selector": favoriteModalCancelButton
  }, "Vazge\xE7"))));
};

/* harmony default export */ var favorite_create_list = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(favorites["a" /* default */]))(favorite_create_list_FavoriteCreateList));
// EXTERNAL MODULE: ./node_modules/shortid/index.js
var shortid = __webpack_require__("je4i");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-popper-footer/styles.module.scss
var favorite_popper_footer_styles_module = __webpack_require__("3ZwB");
var favorite_popper_footer_styles_module_default = /*#__PURE__*/__webpack_require__.n(favorite_popper_footer_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-popper-footer/index.jsx
var favorite_popper_footer_jsx = react_default.a.createElement;





var favorite_popper_footer_FavoritePopperFooter = function FavoritePopperFooter(_ref) {
  var changeCurrentPopperContent = _ref.changeCurrentPopperContent;
  return favorite_popper_footer_jsx("div", {
    className: favorite_popper_footer_styles_module_default.a.newListButton,
    onClick: function onClick() {
      return changeCurrentPopperContent('new-list');
    },
    "data-test-selector": favoriteModalCreateNewListButton
  }, favorite_popper_footer_jsx(desktop_elements["e" /* Icon */], {
    className: favorite_popper_footer_styles_module_default.a.icons,
    name: "add"
  }), favorite_popper_footer_jsx("span", {
    className: favorite_popper_footer_styles_module_default.a.text
  }, "Yeni Liste Olu\u015Ftur"));
};

/* harmony default export */ var favorite_popper_footer = (favorite_popper_footer_FavoritePopperFooter);
// EXTERNAL MODULE: ./src/helpers/image-url-maker/index.js + 4 modules
var image_url_maker = __webpack_require__("1Vvl");

// EXTERNAL MODULE: ./src/utils/string-utils/index.js
var string_utils = __webpack_require__("KNqG");

// EXTERNAL MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-list/favorite-list-item/styles.module.scss
var favorite_list_item_styles_module = __webpack_require__("qRZG");
var favorite_list_item_styles_module_default = /*#__PURE__*/__webpack_require__.n(favorite_list_item_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-list/favorite-list-item/index.jsx

var favorite_list_item_jsx = react_default.a.createElement;










var favorite_list_item_FavoriteListItem = function FavoriteListItem(_ref) {
  var data = _ref.data,
      listingId = _ref.listingId,
      addListingToFavoriteList = _ref.addListingToFavoriteList,
      listingItem = _ref.listingItem,
      handleClosePopper = _ref.handleClosePopper;
  var id = data.id,
      title = data.title,
      count = data.count,
      coverPhotoUrl = data.coverPhotoUrl;
  var coverPhoto = image_url_maker["a" /* default */].scaleImage(coverPhotoUrl, {
    width: 60,
    height: 60
  }, false);

  var handleAddListingToFavoriteList = function handleAddListingToFavoriteList() {
    var _listingItem$location, _listingItem$location2, _listingItem$location3, _listingItem$location4, _listingItem$location5, _listingItem$location6, _listingItem$location7, _listingItem$location8;

    Object(events["o" /* formGTMEventGA4 */])({
      eventName: 'favorite',
      eventParameters: {
        item_id: "".concat(listingId),
        item_type: 'ilan',
        city: Object(string_utils["i" /* slugify */])((_listingItem$location = listingItem.location) === null || _listingItem$location === void 0 ? void 0 : (_listingItem$location2 = _listingItem$location.city) === null || _listingItem$location2 === void 0 ? void 0 : _listingItem$location2.name),
        town: Object(string_utils["i" /* slugify */])((_listingItem$location3 = listingItem.location) === null || _listingItem$location3 === void 0 ? void 0 : (_listingItem$location4 = _listingItem$location3.district) === null || _listingItem$location4 === void 0 ? void 0 : _listingItem$location4.name),
        neighborhood: Object(string_utils["i" /* slugify */])((_listingItem$location5 = listingItem.location) === null || _listingItem$location5 === void 0 ? void 0 : (_listingItem$location6 = _listingItem$location5.town) === null || _listingItem$location6 === void 0 ? void 0 : _listingItem$location6.name),
        district: Object(string_utils["i" /* slugify */])((_listingItem$location7 = listingItem.location) === null || _listingItem$location7 === void 0 ? void 0 : (_listingItem$location8 = _listingItem$location7.locality) === null || _listingItem$location8 === void 0 ? void 0 : _listingItem$location8.name)
      }
    });
    addListingToFavoriteList(id, listingId);
    setTimeout(function () {
      handleClosePopper();
    }, 2000);
  };

  return favorite_list_item_jsx(react_default.a.Fragment, null, favorite_list_item_jsx("div", {
    "data-id": id,
    className: favorite_list_item_styles_module_default.a.itemWrapper,
    "data-test-selector": "".concat(favoriteModalListItem, "-").concat(id)
  }, favorite_list_item_jsx("div", {
    className: favorite_list_item_styles_module_default.a.itemTitle,
    onClick: handleAddListingToFavoriteList
  }, coverPhotoUrl === null ? favorite_list_item_jsx(desktop_elements["e" /* Icon */], {
    className: favorite_list_item_styles_module_default.a.icons,
    name: "favorite_border"
  }) : favorite_list_item_jsx("div", {
    className: favorite_list_item_styles_module_default.a.coverPhoto,
    style: {
      backgroundImage: "url(".concat(coverPhoto, ")")
    }
  }), favorite_list_item_jsx("div", {
    className: favorite_list_item_styles_module_default.a.text
  }, favorite_list_item_jsx("span", {
    className: favorite_list_item_styles_module_default.a.title
  }, title), favorite_list_item_jsx("span", {
    className: favorite_list_item_styles_module_default.a.count
  }, "".concat(count, " ilan"))))));
};

/* harmony default export */ var favorite_list_item = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(favorites["a" /* default */]))(favorite_list_item_FavoriteListItem));
// EXTERNAL MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-list/styles.module.scss
var favorite_list_styles_module = __webpack_require__("JxNw");
var favorite_list_styles_module_default = /*#__PURE__*/__webpack_require__.n(favorite_list_styles_module);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-list/index.jsx
var favorite_list_jsx = react_default.a.createElement;








var favorite_list_FavoriteList = function FavoriteList(_ref) {
  var handleClosePopper = _ref.handleClosePopper,
      changeCurrentPopperContent = _ref.changeCurrentPopperContent,
      favoriteList = _ref.favoriteList,
      listingId = _ref.listingId,
      listingItem = _ref.listingItem;
  return favorite_list_jsx("div", {
    className: favorite_list_styles_module_default.a.wrapper
  }, favorite_list_jsx(favorite_popper_header, {
    onClick: handleClosePopper,
    title: "Favori Listeme Ekle",
    titleTestSelector: favoriteModalAddToListTitle
  }), favorite_list_jsx("div", {
    className: favorite_list_styles_module_default.a.content
  }, favoriteList.map(function (item) {
    return favorite_list_jsx(favorite_list_item, {
      data: item,
      listingItem: listingItem,
      handleClosePopper: handleClosePopper,
      key: shortid_default.a.generate(),
      listingId: listingId
    });
  })), favorite_list_jsx(favorite_popper_footer, {
    changeCurrentPopperContent: changeCurrentPopperContent
  }));
};

/* harmony default export */ var favorite_list = (favorite_list_FavoriteList);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/index.js
var styles = __webpack_require__("SUMQ");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/CircularProgress/index.js
var CircularProgress = __webpack_require__("DKSo");
var CircularProgress_default = /*#__PURE__*/__webpack_require__.n(CircularProgress);

// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-loading/index.jsx
var favorite_loading_jsx = react_default.a.createElement;






var favorite_loading_styles = function styles() {
  return {
    progress: {
      margin: 0,
      color: '#212121',
      height: '36px'
    }
  };
};

var favorite_loading_style = {
  wrapper: {
    height: '300px'
  },
  progressWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '69%'
  }
};

var favorite_loading_Loading = function Loading(_ref) {
  var classes = _ref.classes;
  return favorite_loading_jsx("div", {
    style: favorite_loading_style.progressWrapper
  }, favorite_loading_jsx(CircularProgress_default.a, {
    className: classes.progress,
    size: 36,
    thickness: 5
  }));
};

var favorite_loading_FavoriteLoading = function FavoriteLoading(_ref2) {
  var handleClosePopper = _ref2.handleClosePopper,
      classes = _ref2.classes,
      changeCurrentPopperContent = _ref2.changeCurrentPopperContent;
  return favorite_loading_jsx("div", {
    style: favorite_loading_style.wrapper
  }, favorite_loading_jsx(favorite_popper_header, {
    onClick: handleClosePopper
  }), favorite_loading_jsx(favorite_loading_Loading, {
    classes: classes,
    title: "Listelerim"
  }), favorite_loading_jsx(favorite_popper_footer, {
    changeCurrentPopperContent: changeCurrentPopperContent
  }));
};

/* harmony default export */ var favorite_loading = (Object(styles["withStyles"])(favorite_loading_styles)(favorite_loading_FavoriteLoading));
// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/favorite-error/index.jsx
var favorite_error_jsx = react_default.a.createElement;


var FavoriteError = function FavoriteError() {
  return favorite_error_jsx("div", null, favorite_error_jsx("div", null, "FavoriteError"));
};

/* harmony default export */ var favorite_error = (FavoriteError);
// CONCATENATED MODULE: ./src/components/desktop/favorites/favorite-popper-content/index.jsx









var favorite_popper_content_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }










var favorite_popper_content_RenderView = function RenderView(_ref) {
  var changeCurrentPopperContent = _ref.changeCurrentPopperContent,
      handleClosePopper = _ref.handleClosePopper,
      favoriteList = _ref.favoriteList,
      listingId = _ref.listingId,
      isFavorite = _ref.isFavorite,
      currentPopperContent = _ref.currentPopperContent,
      listingItem = _ref.listingItem;

  switch (currentPopperContent) {
    case 'list':
      return favorite_popper_content_jsx(favorite_list, {
        favoriteList: favoriteList || [],
        listingId: listingId,
        handleClosePopper: handleClosePopper,
        changeCurrentPopperContent: changeCurrentPopperContent,
        isFavorite: isFavorite,
        listingItem: listingItem
      });

    case 'new-list':
      return favorite_popper_content_jsx(favorite_create_list, {
        handleClosePopper: handleClosePopper,
        changeCurrentPopperContent: changeCurrentPopperContent
      });

    case 'empty':
      return favorite_popper_content_jsx(favorite_empty_state, {
        handleClosePopper: handleClosePopper,
        changeCurrentPopperContent: changeCurrentPopperContent
      });

    case 'error':
      return favorite_popper_content_jsx(favorite_error, {
        handleClosePopper: handleClosePopper,
        changeCurrentPopperContent: changeCurrentPopperContent
      });

    default:
      return favorite_popper_content_jsx(favorite_loading, {
        handleClosePopper: handleClosePopper,
        changeCurrentPopperContent: changeCurrentPopperContent
      });
  }
};

var favorite_popper_content_FavoritePopperContent = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(FavoritePopperContent, _React$Component);

  var _super = _createSuper(FavoritePopperContent);

  function FavoritePopperContent(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FavoritePopperContent);

    _this = _super.call(this, props);

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "isFavorite", function () {
      var listingId = _this.props.listingId;
      var allFavoriteListings = _this.state.allFavoriteListings;
      var result = allFavoriteListings === null || allFavoriteListings === void 0 ? void 0 : allFavoriteListings.filter(function (listing) {
        return listing.id === listingId;
      }).map(function (item) {
        return item.listId;
      });
      return result;
    });

    _this.state = {
      favoriteList: props.favoriteList,
      allFavoriteListings: props.allFavoriteListings,
      loading: props.loading,
      error: props.error,
      currentPopperContent: props.currentPopperContent
    };
    return _this;
  }

  Object(createClass["a" /* default */])(FavoritePopperContent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var favoriteList = nextProps.favoriteList,
          allFavoriteListings = nextProps.allFavoriteListings,
          loading = nextProps.loading,
          error = nextProps.error,
          currentPopperContent = nextProps.currentPopperContent;
      this.setState({
        favoriteList: favoriteList,
        allFavoriteListings: allFavoriteListings,
        loading: loading,
        error: error,
        currentPopperContent: currentPopperContent
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleClosePopper = _this$props.handleClosePopper,
          changeCurrentPopperContent = _this$props.changeCurrentPopperContent,
          listingId = _this$props.listingId,
          gtmEventLabel = _this$props.gtmEventLabel,
          listingItem = _this$props.listingItem;
      return favorite_popper_content_jsx("div", null, favorite_popper_content_jsx(favorite_popper_content_RenderView, Object(esm_extends["a" /* default */])({}, this.state, {
        listingId: listingId,
        listingItem: listingItem,
        isFavorite: this.isFavorite,
        handleClosePopper: handleClosePopper,
        changeCurrentPopperContent: changeCurrentPopperContent,
        gtmEventLabel: gtmEventLabel
      })));
    }
  }]);

  return FavoritePopperContent;
}(react_default.a.Component);

/* harmony default export */ var favorite_popper_content = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(favorites["a" /* default */]))(favorite_popper_content_FavoritePopperContent));
// CONCATENATED MODULE: ./src/components/desktop/favorites/index.jsx



var favorites_jsx = react_default.a.createElement;

function favorites_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function favorites_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { favorites_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { favorites_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var favorites_Favorites = function Favorites(_ref) {
  var dataEjCategory = _ref['data-ej-category'],
      dataEjAction = _ref['data-ej-action'],
      dataEjLabel = _ref['data-ej-label'],
      type = _ref.type,
      position = _ref.position,
      style = _ref.style,
      authenticationModalToogle = _ref.authenticationModalToogle,
      _ref$hoverVisible = _ref.hoverVisible,
      hoverVisible = _ref$hoverVisible === void 0 ? function () {} : _ref$hoverVisible,
      detail = _ref.detail,
      listingId = _ref.listingId,
      listingItem = _ref.listingItem,
      itemIndex = _ref.itemIndex,
      _ref$allFavoriteListi = _ref.allFavoriteListings,
      allFavoriteListings = _ref$allFavoriteListi === void 0 ? [] : _ref$allFavoriteListi,
      isAuth = _ref.isAuth,
      pageNumber = _ref.pageNumber,
      newFavoriteListMessageToogle = _ref.newFavoriteListMessageToogle,
      newFavoriteListItemMessageToogle = _ref.newFavoriteListItemMessageToogle,
      gtmEventLabel = _ref.gtmEventLabel,
      removeListingFromFavoriteList = _ref.removeListingFromFavoriteList;

  var _React$useState = react_default.a.useState({
    open: false,
    anchorEl: null
  }),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      states = _React$useState2[0],
      setStates = _React$useState2[1];

  var placement = {
    type: type || 'static',
    position: position || 'bottom-end'
  }; // Popper position

  var repositionPopover = function repositionPopover(event) {
    var targetElement = event.target;
    var rightPosition = targetElement.getBoundingClientRect().right;
    var popperWidth = 1300;

    if (rightPosition - popperWidth > 0 && placement.type === 'dynamic') {
      placement.position = 'bottom-end';
    }
  };

  var isFavorited = function isFavorited() {
    var result = allFavoriteListings === null || allFavoriteListings === void 0 ? void 0 : allFavoriteListings.filter(function (listing) {
      return listing === listingId;
    }).map(function (item) {
      return item;
    });
    return result.length > 0;
  }; // Popper Toogle


  var handleOpenPopper = function handleOpenPopper(event) {
    repositionPopover(event);

    if (isAuth) {
      var currentTarget = event.currentTarget;

      if (isFavorited()) {
        removeListingFromFavoriteList(listingId);
      } else {
        setStates({
          open: !states.open,
          anchorEl: currentTarget
        });
        hoverVisible(!states.open);
        Object(events["j" /* favoritesGTMEvents */])({
          action: 'view',
          label: gtmEventLabel
        });
      }
    } else {
      authenticationModalToogle();
    }
  }; // Close Popper


  var handleClosePopper = function handleClosePopper() {
    setStates(favorites_objectSpread(favorites_objectSpread({}, states), {}, {
      open: false
    }));
    newFavoriteListMessageToogle();
    newFavoriteListItemMessageToogle();
    hoverVisible(false);
  };

  return favorites_jsx(react_default.a.Fragment, null, favorites_jsx(favorite_button, {
    open: states.open,
    onClick: handleOpenPopper,
    placement: placement.position,
    dataEjCategory: dataEjCategory,
    dataEjAction: dataEjAction,
    dataEjLabel: dataEjLabel,
    style: style,
    detail: detail,
    listingId: listingId,
    listingItem: listingItem,
    itemIndex: itemIndex,
    pageNumber: pageNumber,
    isFavorited: isFavorited() && isAuth,
    gtmEventLabel: gtmEventLabel
  }), favorites_jsx(favorite_popper, {
    open: states.open,
    anchorEl: states.anchorEl,
    onClick: handleClosePopper,
    placement: placement.position
  }, favorites_jsx(favorite_popper_content, {
    handleClosePopper: handleClosePopper,
    listingId: listingId,
    listingItem: listingItem
  })));
};

/* harmony default export */ var desktop_favorites = __webpack_exports__["a"] = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(favorites["a" /* default */]))(favorites_Favorites));

/***/ }),

/***/ "y4vh":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"favoriteEmptyState":"_2gUMZt","content":"_31ueD8","textWrapper":"_1J8sgm","text":"_3rUkeQ","listButton":"_2SSJxY"};

/***/ }),

/***/ "ye2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_moment_tr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("mpxu");
/* harmony import */ var _helpers_moment_tr__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_helpers_moment_tr__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var Datef = function Datef(_ref) {
  var value = _ref.value,
      format = _ref.format;
  return __jsx("span", null, _helpers_moment_tr__WEBPACK_IMPORTED_MODULE_1___default.a.utc(value).format(format));
};

/* harmony default export */ __webpack_exports__["a"] = (Datef);

/***/ })

}]);